import logo from 'assets/images/logo/Logo.png';

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
    return <img src={logo} alt='Builder' width='200' />;
};

export default LogoMain;
